<template>
    <div class="content my-0 py-1">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 w-100 my-3">
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <button class="nav-link" :class="{active: selectedTab == 0}" @click="switchMainTab(0)">
                                Airtime Status
                            </button>   
                        </li>
                        <li class="nav-item">
                            <button class="nav-link" :class="{active: selectedTab == 2}" @click="switchMainTab(2)">
                                Status Report KKP
                            </button>
                        </li>
                    </ul>

                    <div class="col-12 my-2 py-0" v-if="selectedTab == 0">
                        <div class="d-flex justify-content-between align-items-center flex-wrap">
                            
                            <ul class="nav nav-tabs border-bottom-0"> 
                                <li v-for="tab in renewalTabs" :key="tab.state" class="nav-item">
                                    <button class="nav-link" :class="{active: selectedTabRenewal == tab.state}" @click="getAirtimeByMonth(tab.state)">
                                        {{ tab.label }}
                                    </button>
                                </li>
                            </ul>

                            <div class="d-flex align-items-center mb-2">
                                <label class="mr-2 mb-0 text-secondary small text-nowrap">Filter Status Device:</label>
                                <select class="form-control form-control-sm" style="width: 200px;" v-model="deviceStatusFilter" @change="fetchAirtimeData()">
                                    <option value="">-- ALL STATUS --</option>
                                    <option v-for="st in statusOptions" :key="st" :value="st">{{ st }}</option>
                                </select>
                            </div>
                            
                        </div>
                        <div class="col-12 my-2 py-0">
                            
                            <datatable  :datas="RenewalAirtimes" 
                                        :structure="RenewalAirtimeTableStructure" 
                                        :init="loadData" 
                                        :next-url="nextUrlAirtime" 
                                        :prev-url="prevUrlAirtime" 
                                        :hide-pagination="true"
                                        @searching="searchResultRenewalAirtime">
                                
                                <template #customcell="{obj,index}">
                                    <td>{{ (current_Page - 1) * per_Page + (index + 1) }}</td>
                                    <td>{{ getDataSafe(obj, 'invoice_item_metadata.order_metadata.hardware_setup.id_transmitter') }}</td>
                                    <td>{{ getDataSafe(obj, 'invoice_item_metadata.order_metadata.hardware_setup.serial_number.serial_number') }}</td>
                                    <td>{{ getDataSafe(obj, 'invoice_item_metadata.order_metadata.hardware_setup.vessel.name') }}</td>
                                    <td>{{ getDataSafe(obj, 'invoice_item_metadata.order_metadata.hardware_setup.vessel.client.legal_name') }}</td>
                                    <td><span class="badge badge-info">{{ getDataSafe(obj, 'invoice_item_metadata.order_metadata.hardware_setup.device_status.status_code') }}</span></td>       
                                    <td>{{ getDataSafe(obj, 'invoice_item_metadata.order_metadata.hardware_setup.forward') }}</td>
                                    <td>{{ formatDate(getDataSafe(obj, 'invoice_item_metadata.order_metadata.hardware_setup.date_due')) }}</td>
                                    <td>{{ obj.invoice_date | timeformat }}</td>
                                    <td>{{ obj.start_period | timeformat }}</td>
                                    <td>{{ obj.finish_date | timeformat }}</td>
                                    <td>{{ getDataSafe(obj, 'invoice_item_metadata.order_metadata.hardware_setup.vessel.client.telephone_pemilik') }}</td>
                                    <td>
                                        <b-dropdown text="Actions" variant="primary" size="sm" class="mb-0" right>
                                            <b-dropdown-header>Sebelum Jatuh Tempo</b-dropdown-header>
                                            
                                            <b-dropdown-item 
                                                v-if="obj && (obj.id || obj.invoice_airtime_id)"
                                                :href="'https://api-billing.megahsurya.com/api/remainder/notifikasi/' + (obj.id ? obj.id : obj.invoice_airtime_id) + '?type=overdue'"
                                                target="_blank"
                                                v-b-tooltip.hover.left="'Membuka berkas PDF cetak Surat Pemberitahuan Pra-Jatuh Tempo'">
                                                <b-icon icon="printer" class="mr-1"></b-icon> Cetak SP
                                            </b-dropdown-item>
                                            
                                            <b-dropdown-item 
                                                @click="openPreview(obj, 'reminder', 'whatsapp')"
                                                v-b-tooltip.hover.left="'Kirim teks draf pengingat tagihan resmi lewat chat WhatsApp manual'">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#25D366" class="bi bi-whatsapp mr-1 align-middle" viewBox="0 0 16 16">
                                                    <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.907h.004c4.368 0 7.926-3.559 7.93-7.93a7.9 7.9 0 0 0-2.327-5.615zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.69-4.294c-.202-.101-1.192-.588-1.376-.654-.182-.066-.315-.099-.445.099-.133.197-.513.654-.627.784-.114.13-.228.145-.43.045-.201-.102-.85-.313-1.619-.992-.598-.534-1.002-1.193-1.12-1.393-.117-.2-.013-.308.088-.408.09-.089.201-.233.301-.35.101-.117.135-.198.202-.33.067-.133.033-.249-.017-.35-.05-.101-.445-1.07-.61-1.47c-.161-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.192-.488 1.36-.957.168-.468.168-.868.118-.953-.05-.084-.183-.134-.384-.235"/>
                                                </svg> Kirim WA
                                            </b-dropdown-item>
                                            
                                            <b-dropdown-item 
                                                @click="openPreview(obj, 'reminder', 'email')"
                                                v-b-tooltip.hover.left="'Kirim lampiran isi surat via aplikasi Email bawaan'">
                                                <b-icon icon="envelope" class="mr-1" variant="primary"></b-icon> Kirim Email
                                            </b-dropdown-item>

                                            <b-dropdown-divider></b-dropdown-divider>

                                            <b-dropdown-header class="text-danger">Sudah Jatuh Tempo</b-dropdown-header>
                                            
                                            <b-dropdown-item 
                                                :href="'https://api-billing.megahsurya.com/api/remainder/notifikasi/' + (obj.id ? obj.id : obj.invoice_airtime_id)" 
                                                target="_blank"
                                                variant="danger"
                                                v-b-tooltip.hover.left="'Membuka berkas PDF Surat Teguran Keras Overdue'">
                                                <b-icon icon="printer" class="mr-1"></b-icon> Cetak SP Overdue
                                            </b-dropdown-item>
                                            
                                            <b-dropdown-item 
                                                @click="openPreview(obj, 'overdue', 'whatsapp')"
                                                v-b-tooltip.hover.left="'Kirim peringatan keras via WhatsApp karena masa aktif telah lewat'">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#25D366" class="bi bi-whatsapp mr-1 align-middle" viewBox="0 0 16 16">
                                                    <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.907h.004c4.368 0 7.926-3.559 7.93-7.93a7.9 7.9 0 0 0-2.327-5.615zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.69-4.294c-.202-.101-1.192-.588-1.376-.654-.182-.066-.315-.099-.445.099-.133.197-.513.654-.627.784-.114.13-.228.145-.43.045-.201-.102-.85-.313-1.619-.992-.598-.534-1.002-1.193-1.12-1.393-.117-.2-.013-.308.088-.408.09-.089.201-.233.301-.35.101-.117.135-.198.202-.33.067-.133.033-.249-.017-.35-.05-.101-.445-1.07-.61-1.47c-.161-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.192-.488 1.36-.957.168-.468.168-.868.118-.953-.05-.084-.183-.134-.384-.235"/>
                                                </svg> Kirim WA Overdue
                                            </b-dropdown-item>
                                            
                                            <b-dropdown-item 
                                                @click="openPreview(obj, 'overdue', 'email')"
                                                v-b-tooltip.hover.left="'Kirim teguran lewat email ke pemilik kapal'">
                                                <b-icon icon="envelope" class="mr-1" variant="primary"></b-icon> Kirim Email Overdue
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </td>
                                </template>
                            </datatable>
                            
                            <div class="d-flex justify-content-between align-items-center mt-2" v-if="RenewalAirtimes">
                                <div class="text-muted small">Showing {{ RenewalAirtimes.length }} of {{ total }} entries</div>
                                <div>
                                    <b-button size="sm" variant="outline-primary" class="mr-2" :disabled="!prevUrlAirtime" @click="changePageAirtime(false)">Prev</b-button>
                                    <b-button size="sm" variant="outline-primary" :disabled="!nextUrlAirtime" @click="changePageAirtime(true)">Next</b-button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 w-100 my-3" v-if="selectedTab == 2">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h6 class="text-secondary m-0 font-weight-bold">REPORT PSDKP</h6>
                            <div class="d-flex align-items-center">
                                <label class="mr-2 mb-0 text-secondary small">Filter Status Device:</label>
                                <select class="form-control form-control-sm" style="width: 200px;" v-model="deviceStatusFilter" @change="fetchStatusReport()">
                                    <option value="">SUSPENSIONS & EXPIRED</option>
                                    <option v-for="st in statusOptions" :key="st" :value="st">{{ st }}</option>
                                </select>
                            </div>
                        </div>

                        <datatable v-if="filteredAirtimes" 
                                   :datas="filteredAirtimes" 
                                   :structure="fileterAirtimeTableStructure" 
                                   :init="loadDataItem" 
                                   :next-url="nextUrlReport" 
                                   :prev-url="prevUrlReport" 
                                   :hide-pagination="true"
                                   @searching="searchResultReport">
                            
                            <template #customcell="{obj,index}">
                                <td>{{ (currentPage - 1) * perPage + (index + 1) }}</td>
                                <td>{{ getDataSafe(obj, 'invoice_item_metadata.order_metadata.hardware_setup.id_transmitter') }}</td>
                                <td>{{ getDataSafe(obj, 'invoice_item_metadata.order_metadata.hardware_setup.serial_number.serial_number') }}</td>
                                <td>{{ getDataSafe(obj, 'invoice_item_metadata.order_metadata.hardware_setup.vessel.name') }}</td>
                                <td>{{ getDataSafe(obj, 'invoice_item_metadata.order_metadata.hardware_setup.vessel.client.legal_name') }}</td>
                                <td>
                                    <span class="badge badge-info">
                                        {{ getDataSafe(obj, 'invoice_item_metadata.order_metadata.hardware_setup.device_status.status_code') }}
                                    </span>
                                </td>
                                <td>{{ getDataSafe(obj, 'invoice_item_metadata.order_metadata.hardware_setup.forward') }}</td>
                                <td>{{ obj.invoice_date | timeformat }}</td>
                                <td>{{ obj.start_period | timeformat }}</td>
                                <td>{{ obj.finish_date | timeformat }}</td>
                                <td>{{ getDataSafe(obj, 'invoice_item_metadata.order_metadata.hardware_setup.vessel.client.telephone_pemilik') }}</td>
                            </template>
                        </datatable>

                        <div class="d-flex justify-content-between align-items-center mt-2" v-if="filteredAirtimes">
                            <div class="text-muted small">Showing {{ filteredAirtimes.length }} of {{ total }} entries</div>
                            <div>
                                <b-button size="sm" variant="outline-primary" class="mr-2" :disabled="!prevUrlReport" @click="changePageReport(false)">Prev</b-button>
                                <b-button size="sm" variant="outline-primary" :disabled="!nextUrlReport" @click="changePageReport(true)">Next</b-button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <b-modal id="modal-preview-kirim" title="Detail & Edit Billing Statement Content" centered size="lg" scrollable>
            <b-row class="mb-3">
                <b-col md="6">
                    <b-form-group label="Media Pengiriman:">
                        <b-badge :variant="previewData.media === 'whatsapp' ? 'success' : 'primary'" class="px-3 py-2" style="font-size: 14px;">
                            <b-icon :icon="previewData.media === 'whatsapp' ? 'whatsapp' : 'envelope'" class="mr-1"></b-icon>
                            {{ previewData.media === 'whatsapp' ? 'WhatsApp (Chat)' : 'Email Client' }}
                        </b-badge>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group :label="previewData.media === 'whatsapp' ? 'No. WhatsApp Pemilik:' : 'Email Tujuan:'">
                        <b-form-input v-model="previewData.tujuan" placeholder="Masukkan kontak tujuan..."></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-form-group label="Subject / Perihal:" v-if="previewData.media === 'email'">
                <b-form-input v-model="previewData.emailSubject" placeholder="Masukkan perihal email..."></b-form-input>
            </b-form-group>

            <div class="d-flex justify-content-between align-items-center mb-2">
                <label class="font-weight-bold mb-0">Isi Surat:</label>
                <b-form-checkbox v-model="isEditMode" switch size="md" class="text-primary font-weight-bold">
                    {{ isEditMode ? 'Mode Edit Teks aktif' : 'Aktifkan Mode Edit Teks' }}
                </b-form-checkbox>
            </div>

            <b-form-group>
                <b-form-textarea 
                    v-if="isEditMode"
                    v-model="previewData.pesan" 
                    rows="15" 
                    max-rows="22"
                    style="font-family: 'Courier New', Courier, monospace; font-size: 14px; line-height: 1.5; color: #212529;">
                </b-form-textarea>

                <div 
                    v-else
                    v-html="renderBoldText(previewData.pesan)" 
                    class="p-3 border rounded text-monospace"
                    style="font-size: 14px; line-height: 1.6; white-space: pre-wrap; background-color: #f8f9fa; color: #212529; min-height: 340px; max-height: 500px; overflow-y: auto;">
                </div>
            </b-form-group>

            <template #modal-footer="{ cancel }">
                <b-button size="sm" variant="secondary" @click="cancel()">
                    <b-icon icon="x-circle" class="mr-1"></b-icon> Batal
                </b-button>
                <b-button size="sm" :variant="previewData.media === 'whatsapp' ? 'success' : 'primary'" @click="FinalSubmissionProcess()">
                    <b-icon :icon="previewData.media === 'whatsapp' ? 'paper-plane' : 'envelope-open'" class="mr-1"></b-icon>
                    Proses Kirim Sekarang
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import * as axios from "axios";
import Datatable from "../../components/Datatable.vue";

export default {
    components: { "datatable": Datatable },
    data() {
        return {
            perPageAirtime: 10,
            selectedTab: 0,
            selectedTabRenewal: 10,
            deviceStatusFilter: "",
            loadData: false,
            loadDataItem: false,
            nextUrlAirtime: null, prevUrlAirtime: null, current_Page: 1, per_Page: 10,
            nextUrlReport: null, prevUrlReport: null, currentPage: 1, perPage: 10,
            total: 0,
            RenewalAirtimes: [],
            filteredAirtimes: [], 
            statusOptions: [
                'ACTIVE', 'NOT-ACTIVE', 'ACTIVE NG', 'DE-ACTIVE', 'MAINTENANCE', 
                'BROKEN', 'STANDBY', 'SUSPENSIONS', 'EXPIRED', 'DOCKING'
            ],
            renewalTabs: [
                { state: 10, label: "ALL" },
                { state: 0,  label: "3 months" },
                { state: 1,  label: "2 months" },
                { state: 2,  label: "1 months" },
                { state: 5,  label: "3 weeks" },
                { state: 6,  label: "2 weeks" },
                { state: 7,  label: "1 weeks" },
                { state: 8,  label: "Tomorrow" },
                { state: 9,  label: "+2 days" },
                { state: 3,  label: "Grace period" },
                { state: 4,  label: "Not active" }
            ],
            isEditMode: false,
            previewData: {
                tujuan: '',
                pesan: '',
                media: '', 
                emailSubject: ''
            },
            RenewalAirtimeTableStructure: [
                {label: "NO"}, {label: "SPKP ID"}, {label: "SERIAL NUMBER"}, {label: "VESSEL NAME"}, {label: "CUSTOMER"},
                {label: "DEVICE STATUS"}, {label: "STATUS REPORT"}, {label: "SETUP DATE"}, {label: "INVOICE DATE"}, 
                {label: "START OF AIRTIME"}, {label: "END OF AIRTIME"}, {label: "TELP PIC"}, {label: "ACTION"}
            ],
            fileterAirtimeTableStructure: [
                {label: "NO"}, {label: "SPKP ID"}, {label: "SERIAL NUMBER"}, {label: "VESSEL NAME"}, {label: "CUSTOMER"}, 
                {label: "DEVICE STATUS"}, {label: "STATUS REPORT"}, {label: "INVOICE DATE"}, {label: "START OF AIRTIME"}, 
                {label: "END OF AIRTIME"}, {label: "TELP PIC"}
            ]
        };
    },
    created() {
        this.fetchAirtimeData(); 
    },
    mounted() {
        if (this.$route.query.status) {
            this.deviceStatusFilter = this.$route.query.status;
        }
        this.fetchStatusReport();
        
        const tab = this.$route.query.tab;
        const status = this.$route.query.status;

        if (tab) {
            this.selectedTab = parseInt(tab);
        }
        if (status) {
            this.deviceStatusFilter = status;
        }
        
        if (this.selectedTab === 2) {
            this.fetchStatusReport();
        } else {
            this.fetchAirtimeData();
        }
    },
    watch: {
        '$route.query.status'(newStatus) {
            this.deviceStatusFilter = newStatus || '';
            this.fetchStatusReport();
        }
    },
    methods: {
        handleRowChange(newRow) {
            this.perPageAirtime = newRow;
            this.fetchAirtimeData();
        },
        switchMainTab(tabIndex) {
            this.selectedTab = tabIndex;
            if (tabIndex === 0) this.fetchAirtimeData();
            if (tabIndex === 2) this.fetchStatusReport();
        },
        getDataSafe(obj, path) {
            const value = path.split('.').reduce((acc, part) => acc && acc[part], obj);
            return value !== undefined && value !== null ? value : "-";
        },
        fetchAirtimeData(url = null) {
            this.loadData = true;
            const isHttps = this.$baseUrl.startsWith('https://');
            let targetUrl = url;
            
            if (!targetUrl) {
                targetUrl = `${this.$baseUrl}/api/pemesanan/pengingat/from/airtime?all=all`;
            } else {
                targetUrl = isHttps ? targetUrl.replace("http://", "https://") : targetUrl.replace("https://", "http://");
            }

            if (this.deviceStatusFilter) {
                const urlObj = new URL(targetUrl);
                urlObj.searchParams.set('search_status', this.deviceStatusFilter);
                targetUrl = urlObj.toString();
            }
            
            axios.get(targetUrl, { 
                headers: { "Authorization": "Bearer " + localStorage.getItem("accessToken") } 
            })
            .then(res => {
                this.RenewalAirtimes = res.data.data || [];
                this.nextUrlAirtime = res.data.next_page_url;
                this.prevUrlAirtime = res.data.prev_page_url;
                this.current_Page = res.data.current_page;
                this.total = res.data.total;
            })
            .catch(err => {
                console.error("Error Fetch Airtime:", err);
                this.RenewalAirtimes = [];
            })
            .finally(() => { 
                this.loadData = false; 
            });
        },
        fetchStatusReport(url = null) {
            this.loadDataItem = true;
            const currentProtocol = window.location.protocol; 
            let baseUrl = this.$baseUrl.replace(/^https?:\/\//, currentProtocol + "//");
            let targetUrl = url ? url.replace(/^https?:\/\//, currentProtocol + "//") : `${baseUrl}/api/pemesanan/pengingat/from/airtime?all=all`;

            const separator = targetUrl.includes('?') ? '&' : '?';
            if (this.deviceStatusFilter) {
                targetUrl += `${separator}search_status=${this.deviceStatusFilter}`;
            } else {
                targetUrl += `${separator}search_status[]=SUSPENSIONS&search_status[]=EXPIRED`;
            }

            axios.get(targetUrl, { headers: { "Authorization": "Bearer " + localStorage.getItem("accessToken") } })
                .then(res => {
                    this.filteredAirtimes = res.data.data || [];
                    this.nextUrlReport = res.data.next_page_url;
                    this.prevUrlReport = res.data.prev_page_url;
                    this.currentPage = res.data.current_page;
                    this.total = res.data.total;
                })
                .catch(err => {
                    console.error("Fetch Error:", err);
                    this.filteredAirtimes = [];
                })
                .finally(() => { this.loadDataItem = false; });
        },
        changePageReport(isNext) {
            let url = isNext ? this.nextUrlReport : this.prevUrlReport;
            if (url) this.fetchStatusReport(url);
        },
        changePageAirtime(isNext) {
            let url = isNext ? this.nextUrlAirtime : this.prevUrlAirtime;
            if (url) this.fetchAirtimeData(url);
        },
        getAirtimeByMonth(state) {
            this.selectedTabRenewal = state;
            const map = ["3month", "2month", "1month", "over1month", "over2month", "3week", "2week", "1week", "1day", "minus2day"];
            let url = `${this.$baseUrl}/api/pemesanan/pengingat/from/airtime?all=all&status=${map[state]}`;
            
            if (this.deviceStatusFilter) {
                url += `&search_status=${this.deviceStatusFilter}`;
            }
            this.fetchAirtimeData(url);
        },
        searchResultRenewalAirtime(val) { 
            if (val && val.status && val.data) {
                this.RenewalAirtimes = val.data.data || [];
                this.nextUrlAirtime = val.data.next_page_url;
                this.prevUrlAirtime = val.data.prev_page_url;
                this.current_Page = val.data.current_page;
            }
        },
        searchResultReport(val) { 
            if (val && val.status && val.data) {
                this.filteredAirtimes = val.data.data || []; 
                this.nextUrlReport = val.data.next_page_url;
                this.prevUrlReport = val.data.prev_page_url;
                this.currentPage = val.data.current_page;
                this.total = val.data.total;
            }
        },
        formatDate(d) { 
            if (!d || d === "-") return "-";
            try {
                return new Date(d).toLocaleDateString('id-ID', {day:'2-digit', month:'long', year:'numeric'});
            } catch (e) { return "-"; }
        },
        getPeriod(f) { 
            if (!f) return null;
            return Math.floor((new Date(f) - new Date()) / 86400000); 
        },
        colorPeriod(p) {
            if (p === null || p === undefined) return "";
            if (p > 0 && p <= 7) return "bg-orange";
            if (p > 7 && p <= 30) return "bg-yellow";
            if (p <= 0 && p >= -14) return "bg-blue";
            if (p < -14) return "bg-green";
            return "";
        },
        formatWhatsAppNumber(phone) {
            if (!phone) return '';
            let cleaned = phone.replace(/\D/g, '');
            if (cleaned.startsWith('0')) {
                cleaned = '62' + cleaned.substring(1);
            }
            return cleaned;
        },
        angkaKeTerbilang(nilai) {
            let angka = Math.floor(Math.abs(nilai));
            let huruf = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan", "Sepuluh", "Sebelas"];
            let temp = "";
            
            if (angka < 12) {
                temp = " " + huruf[angka];
            } else if (angka < 20) {
                temp = this.angkaKeTerbilang(angka - 10) + " Belas";
            } else if (angka < 100) {
                temp = this.angkaKeTerbilang(angka / 10) + " Puluh" + this.angkaKeTerbilang(angka % 10);
            } else if (angka < 200) {
                temp = " Seratus" + this.angkaKeTerbilang(angka - 100);
            } else if (angka < 1000) {
                temp = this.angkaKeTerbilang(angka / 100) + " Ratus" + this.angkaKeTerbilang(angka % 100);
            } else if (angka < 2000) {
                temp = " Seribu" + this.angkaKeTerbilang(angka - 1000);
            } else if (angka < 1000000) {
                temp = this.angkaKeTerbilang(angka / 1000) + " Ribu" + this.angkaKeTerbilang(angka % 1000);
            } else if (angka < 1000000000) {
                temp = this.angkaKeTerbilang(angka / 1000000) + " Juta" + this.angkaKeTerbilang(angka % 1000000);
            }
            return temp.trim();
        },

        renderBoldText(text) {
            if (!text) return "";
            return text.replace(/\*(.*?)\*/g, "<strong>$1</strong>");
        },

        openPreview(obj, statusType, mediaType) {
            this.isEditMode = false;

            // Safely retrieve data from the invoice metadata object
            const namaKapal = this.getDataSafe(obj, 'invoice_item_metadata.order_metadata.hardware_setup.vessel.name') || '-';
            const namaPemilik = this.getDataSafe(obj, 'invoice_item_metadata.order_metadata.hardware_setup.vessel.client.legal_name') || '-';
            const idTransmitter = this.getDataSafe(obj, 'invoice_item_metadata.order_metadata.hardware_setup.id_transmitter') || '-';
            const jatuhTempo = this.formatDate(this.getDataSafe(obj, 'invoice_item_metadata.order_metadata.hardware_setup.date_due')) || '-';
            const telpPemilik = this.getDataSafe(obj, 'invoice_item_metadata.order_metadata.hardware_setup.vessel.client.telephone_pemilik') || '';
            const emailPemilik = this.getDataSafe(obj, 'invoice_item_metadata.order_metadata.hardware_setup.vessel.client.email') || '';
            
            // Retrieve date data to combine into a single service period
            const startDate = this.formatDate(this.getDataSafe(obj, 'start_period')) || '-';
            const endDate = this.formatDate(this.getDataSafe(obj, 'finish_date')) || '-';
            const masaLayanan = `${startDate} s/d ${endDate}`;
            const deadlines = `${endDate}`;
            // ENTER THE COMPANY FINANCE WHATSAPP NUMBER HERE
            const waFinance = "08221222631"; 

            // ====================================================================
            // Dynamic and automatic real-time total data acquisition
            // ====================================================================
            let totalBayarRaw = parseFloat(this.getDataSafe(obj, 'total') || 0);
            
            let formatRupiahTotal = new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(totalBayarRaw).replace("IDR", "Rp.");
            let teksTerbilangTotal = this.angkaKeTerbilang(totalBayarRaw) + " Rupiah";

            // Get the date from the JSON
            const startDate1 = new Date(obj.start_period);
            const finishDate = new Date(obj.finish_date);

            let numberOfMonths =
                (finishDate.getFullYear() - startDate1.getFullYear()) * 12 +
                (finishDate.getMonth() - startDate1.getMonth());

            if (finishDate.getDate() < startDate1.getDate()) {
                numberOfMonths--;
            }

            // Service period format
            let textMasaService = "";

            if (numberOfMonths < 12) {
                textMasaService = `(${numberOfMonths}) bulan`;
            } else if (numberOfMonths === 12) {
                textMasaService = `(1) tahun`;
            } else {
                const tahun = Math.floor(numberOfMonths / 12);
                const bulan = numberOfMonths % 12;

                if (bulan === 0) {
                    textMasaService = `(${tahun}) tahun`;
                } else {
                    textMasaService = `(${tahun}) tahun (${bulan}) bulan`;
                }
            }

        
            // ====================================================================
            // Drafting Message Content Based on Status (Reminder vs. Overdue)
            // ====================================================================
            let isiSurat = `Halo Bapak/Ibu Pelanggan *PT. Megah Surya Persada*,\n\n`;
            isiSurat += `Terima kasih telah mempercayakan layanan Airtime Satelit kepada PT. Megah Surya Persada.\n\n`;
            
            if (statusType === 'reminder') {
                // ---TEMPLATE A: BEFORE DUE DATE (REMINDER) ---
                isiSurat += `Izin mengingatkan bahwa tagihan layanan Bapak/Ibu yang akan segera jatuh tempo dengan rincian data sebagai berikut:\n\n`;

                // Monospace Bill Detail Block
                isiSurat += `*Detail Tagihan Airtime:*\n`;
                isiSurat += "\n";
                isiSurat += `Nama Kapal         : ${namaKapal}\n`;
                isiSurat += `Nama Pemilik       : ${namaPemilik}\n`;
                isiSurat += `ID Transmitter     : ${idTransmitter}\n`;
                // ---isiSurat += `Masa Layanan       : ${masaLayanan}\n`; ---
                isiSurat += `Tanggal Jatuh Tempo: ${deadlines}\n`;
                isiSurat += "\n\n";

                // The total value is automatically and neatly displayed here.
                isiSurat += `*Jumlah Pembayaran:*\n`;
                isiSurat += `*${formatRupiahTotal}*,- *(${teksTerbilangTotal})* untuk masa layanan *${textMasaService}*.`;

                // Monospace Block Bank Account
                isiSurat += `*Silakan melakukan pembayaran ke rekening berikut:*\n`;
                isiSurat += "\n";
                isiSurat += `Bank               : BCA\n`;
                isiSurat += `Nomor Rekening     : 6840 263 311\n`;
                isiSurat += `Atas Nama          : PT. Megah Surya Persada\n`;
                isiSurat += "\n\n";

                // Notes
                isiSurat += `*Catatan:*\n`;
                isiSurat += "\n";
                isiSurat += ` - Bahwa tarif airtime untuk kapal perikanan yang semula\n`;
                isiSurat += `   Rp 6.000.000 (Enam Juta Rupiah) disesuaikan menjadi\n`;
                isiSurat += `   Rp 7.000.000 (Tujuh Juta Rupiah) per tahun.\n`;
                isiSurat += ` - Harga tersebut belum termasuk PPN 11%\n`;
                isiSurat += ` - Penyesuaian Tarif airtime di atas tersebut berlaku\n`;
                isiSurat += `   untuk kapal perikanan di atas 30 GT\n`;
                isiSurat += "\n\n";

                // Determinants of Payment Media Instructions
                if (mediaType === 'whatsapp') {
                    isiSurat += `Setelah pembayaran dilakukan, mohon kirimkan bukti transfer melalui *WhatsApp ini* atau melalui email *sales@megahsurya.com* dengan mencantumkan nama kapal dan ID Transmitter agar proses verifikasi dapat segera kami lakukan.\n\n`;
                    isiSurat += `Apabila Bapak/Ibu memerlukan informasi lebih lanjut, silakan hubungi kami langsung melalui *WhatsApp ini*.\n\n`;
                } else {
                    isiSurat += `Setelah pembayaran dilakukan, mohon kirimkan bukti transfer dengan membalas email ini atau ke *sales@megahsurya.com* dengan mencantumkan nama kapal dan ID Transmitter agar proses verifikasi dapat segera kami lakukan.\n\n`;
                    isiSurat += `Apabila dalam waktu jatuh tempo tersebut belum di lakukan pembayaran maka data akan kami nonaktifkan. Untuk informasi lebih lanjut, hubungi kami melalui email tersebut di atas atau via WhatsApp Finance di nomor *${waFinance}*.\n\n`;
                }

            } else {
                // ====================================================================
                // --- TEMPLATE B: POST-DUE DATE (OVERDUE/DEACTIVATION PENONAKTIVAN) ---
                // ====================================================================
                isiSurat += `Mengingat setelah penonaktifan layanan VMS Tracking maka semua data transmitter dan tracking sebelum masih disimpan di cloud kami. Layanan VMS tracking tersebut dapat diaktifkan kembali apabila pemilik kapal memenuhi ketentuan sebagai berikut:\n\n`;
                
                isiSurat += ` - Melunasi tagihan airtime sampai dengan penonaktifan\n`;
                isiSurat += ` - Membayar biaya Reactive + PPN 11% sebesar *Rp 1.110.000,-*\n`;
                isiSurat += ` - Membayar Airtime untuk periode 1 (satu) tahun sejak tanggal diaktifkan kembali sebesar *${formatRupiahTotal},-*\n\n`;

                // Monospace Block: Related Vessel Technical Details
                isiSurat += `*Data Layanan Terkait:*\n`;
                isiSurat += "\n";
                isiSurat += `Nama Kapal         : ${namaKapal}\n`;
                isiSurat += `Nama Pemilik       : ${namaPemilik}\n`;
                isiSurat += `ID Transmitter     : ${idTransmitter}\n`;
                isiSurat += `Masa Layanan Lama  : ${masaLayanan}\n`;
                isiSurat += `Tanggal Jatuh Tempo: ${jatuhTempo}\n`;
                isiSurat += "\n\n";

                isiSurat += `*Silakan melakukan penyelesaian administrasi ke rekening resmi perusahaan:*\n`;
                isiSurat += "\n";
                isiSurat += `Bank               : BCA\n`;
                isiSurat += `Nomor Rekening     : 6840 263 311\n`;
                isiSurat += `Atas Nama          : PT. Megah Surya Persada\n`;
                isiSurat += "\n\n";

                // Note
                isiSurat += `*Catatan:*\n`;
                isiSurat += "\n";
                isiSurat += ` - Bahwa tarif airtime untuk kapal perikanan yang semula\n`;
                isiSurat += `   Rp 6.000.000 (Enam Juta Rupiah) disesuaikan menjadi\n`;
                isiSurat += `   Rp 7.000.000 (Tujuh Juta Rupiah) per tahun.\n`;
                isiSurat += ` - Harga tersebut belum termasuk PPN 11%\n`;
                isiSurat += ` - Penyesuaian Tarif airtime di atas tersebut berlaku\n`;
                isiSurat += `   untuk kapal perikanan di atas 30 GT\n`;
                isiSurat += "\n\n";

                if (mediaType === 'whatsapp') {
                    isiSurat += `Mohon konfirmasikan bukti transfer pelunasan dan reaktivasi Anda via *WhatsApp ini* atau email ke *sales@megahsurya.com* agar tim teknis kami dapat segera memproses pengaktifan kembali unit tracking VMS kapal Anda.\n\n`;
                } else {
                    isiSurat += `Mohon konfirmasikan bukti transfer pelunasan dan reaktivasi Anda dengan membalas email ini atau ke *sales@megahsurya.com* agar tim teknis kami dapat segera memproses pengaktifan kembali unit tracking VMS kapal Anda. Hubungi nomor Finance di *${waFinance}* jika ada kendala.\n\n`;
                }
            }
            
            isiSurat += `Terima kasih atas perhatian dan kerja samanya.\n\n`;
            isiSurat += `Hormat kami,\n`;
            isiSurat += `*PT. Megah Surya Persada*.\n`;
            isiSurat += `Finance`;

            this.previewData.media = mediaType;
            this.previewData.pesan = isiSurat;
            
            if (mediaType === 'whatsapp') {
                this.previewData.tujuan = telpPemilik;
            } else {
                this.previewData.tujuan = emailPemilik ? emailPemilik : 'sales@megahsurya.com';
                this.previewData.emailSubject = statusType === 'reminder' 
                    ? `Informasi Tagihan Airtime Jatuh Tempo - ${namaKapal}` 
                    : `Penonaktifan Layanan VMS Tracking - ${namaKapal}`;
            }

            this.$bvModal.show('modal-preview-kirim');
        },

        FinalSubmissionProcess() {
            if (!this.previewData.tujuan) {
                this.$bvToast.toast('Kolom kontak tujuan pengiriman tidak boleh kosong!', {
                    title: 'Peringatan Validasi',
                    variant: 'warning',
                    solid: true
                });
                return;
            }

            const self = this;

            // ====================================================================
            // SKENARIO A: WHATSAPP UNIVERSAL (MOBILE, DESKTOP PC, UBUNTU, & WA WEB)
            // ====================================================================
            if (this.previewData.media === 'whatsapp') {
                const formattedPhone = this.formatWhatsAppNumber(this.previewData.tujuan);
                if (!formattedPhone) {
                    this.$bvToast.toast('Format nomor telepon WhatsApp tidak valid atau kode negara salah!', {
                        title: 'Error Kontak Tujuan',
                        variant: 'danger',
                        solid: true
                    });
                    return;
                }

                const encodedText = encodeURIComponent(this.previewData.pesan);
                
                const userAgent = navigator.userAgent || navigator.vendor || window.opera;
                const isMobile = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);

                let triggerSuccess = false;

                if (isMobile) {
                    // MOBILE PATH: Launches the WhatsApp app directly on your phone without opening a new tab.
                    const link = document.createElement('a');
                    link.href = `whatsapp://send?phone=${formattedPhone}&text=${encodedText}`;
                    link.target = '_self'; 
                    link.click();
                    triggerSuccess = true;
                } else {
                    // PC/DESKTOP PATH (WINDOWS, MAC, UBUNTU LINUX, & WEB BROWSER)
                    // Using the 'api.whatsapp.com' domain is the safest and free solution.
                    // If the computer has the WhatsApp Desktop app installed, the browser automatically redirects the user to the app.
                    // If the computer does not have the app, the user simply clicks the "Use WhatsApp Web" button on the screen.
                    const waUrl = `https://api.whatsapp.com/send?phone=${formattedPhone}&text=${encodedText}`;
                    
                    // Open in a new tab and keep it open so the chat draft synchronization process completes successfully!
                    const waWindow = window.open(waUrl, '_blank');
                    
                    if (waWindow) {
                        triggerSuccess = true;
                    } else {
                        triggerSuccess = false;
                    }
                }
                
                this.$bvModal.hide('modal-preview-kirim');

                if (triggerSuccess) {
                    this.Showmanualconfirmation('WhatsApp');
                } else {
                    this.$bvToast.toast('Gagal membuka WhatsApp! Pastikan browser Anda mengizinkan akses blokir Pop-up.', {
                        title: 'Aplikasi Tidak Merespon',
                        variant: 'danger',
                        solid: true,
                        autoHideDelay: 5000
                    });
                }
            } 
            // ====================================================================
            // SCENARIO B: IF THE MEDIUM IS EMAIL
            // ====================================================================
            else if (this.previewData.media === 'email') {
                this.$bvModal.hide('modal-preview-kirim');
                const cleanEmailBody = this.previewData.pesan.replace(/\*/g, '');

                const payload = {
                    to_email: this.previewData.tujuan,
                    subject: this.previewData.emailSubject,
                    message_body: cleanEmailBody
                };

                axios.post(`${this.$baseUrl}/api/send-airtime-email`, payload, {
                    headers: { 
                        "Authorization": "Bearer " + localStorage.getItem("accessToken"),
                        "Accept": "application/json",
                        "Content-Type": "application/json"
                    }
                })
                .then(res => {
                    //Email Notification Success (Guaranteed to trigger via the 'self' instance variable)
                    self.$bvToast.toast('Email pengingat tagihan airtime berhasil dikirim ke server Mailgun dan tercatat di database log!', {
                        title: 'Pengiriman Email Sukses',
                        variant: 'success',
                        solid: true,
                        autoHideDelay: 5000
                    });
                })
                .catch(err => {
                    let errorMessage = "Terjadi kesalahan koneksi atau internal server API.";
                    if (err && err.response && err.response.data && err.response.data.message) {
                        errorMessage = err.response.data.message;
                    }

                    //EMAIL FAILURE NOTIFICATION (Guaranteed to crash via 'self' instance variable)
                    self.$bvToast.toast(`Gagal mengirim email ke server tujuan: ${errorMessage}`, {
                        title: 'Pengiriman Email Gagal',
                        variant: 'danger',
                        solid: true,
                        autoHideDelay: 8000
                    });
                    console.error("API Email Error Details:", err);
                });
            }
        },

        Showmanualconfirmation(mediaLabel) {
            setTimeout(() => {
                this.$bvModal.msgBoxConfirm('Silakan konfirmasi status pengiriman tagihan Anda di aplikasi WhatsApp:', {
                    title: 'Pelaporan Log Status Pengiriman',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Ya, Sukses Terkirim',
                    cancelVariant: 'warning',
                    cancelTitle: 'Nomor Tidak Terdaftar (WA Error)',
                    footerClass: 'p-2 d-flex justify-content-end gap-2',
                    hideHeaderClose: false,
                    noCloseOnBackdrop: true, 
                    centered: true
                })
                .then(value => {
                    if (value === true) {
                        // NOTIFIKASI SUKSES WHATSAPP (Hijau)
                        this.$bvToast.toast(`Notifikasi pengingat via ${mediaLabel} sukses diproses dan dicatat ke log sistem.`, {
                            title: 'Pengiriman Sukses', 
                            variant: 'success', 
                            solid: true, 
                            autoHideDelay: 4000
                        });
                    } else if (value === false) {
                        // NOTIFIKASI ADUAN: NOMOR TIDAK TERDAFTAR (Kuning)
                        this.$bvToast.toast(`Log dicatat: Nomor tujuan tidak terdaftar di WhatsApp. Mohon perbarui database kontak klien Anda.`, {
                            title: 'Nomor Tidak Aktif (Error)', 
                            variant: 'warning', 
                            solid: true, 
                            autoHideDelay: 6000
                        });
                    }
                })
                .catch(err => {
                    this.$bvToast.toast(`Proses pelaporan log via ${mediaLabel} ditutup tanpa memilih status.`, {
                        title: 'Pengiriman Ditunda', 
                        variant: 'info', 
                        solid: true, 
                        autoHideDelay: 4000
                    });
                });
            }, 600);
        }
    }
};
</script>

<style scoped>
.bg-orange { 
    background-color: #ffa500 !important; 
    color: #fff; 
}
.bg-yellow { 
    background-color: #ffff00 !important; 
    color: #000; 
}
.bg-blue { 
    background-color: #007bff !important; 
    color: #fff; 
}
.bg-green { 
    background-color: #28a745 !important; 
    color: #fff; 
}
.nav-link { 
    cursor: pointer; 
    border: none; 
    background: transparent; 
}
.nav-link.active { 
    font-weight: bold; 
    color: #007bff !important; 
    border-bottom: 3px solid #007bff; 
    border-radius: 0; 
}
.nav-tabs {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    white-space: nowrap;
}
.nav-item {
    white-space: nowrap;
}
</style>